import React, { Component } from 'react';

import { getUser } from '../actions/session';
import axiosInstance from '../config/axiosConfig';
import { Notifications } from '../components/common/notification';
import { USER_CREATE_SERVER_URL } from '../config/rest_endpoints';

/**
 * AddServerConfig - Premium Server Configuration Form
 *
 * Modal form for adding new server configurations with
 * beautiful styling and smooth interactions.
 */
class AddServerConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      ip: '',
      port: 5060,
      mask: 32,
      switched: true,
      isLoad: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.toggleSwitch = this.toggleSwitch.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.clearForm = this.clearForm.bind(this);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  toggleSwitch() {
    this.setState({ switched: !this.state.switched });
  }

  clearForm() {
    this.setState({
      ip: '',
      port: '',
      mask: '',
      switched: true
    });
  }

  onSubmitForm() {
    const { ip, port, mask, switched, User } = this.state;
    if (!User || !User.id) return;
    let userId = User.id;
    var payLoad = {
      ip: ip,
      port: parseInt(port),
      mask: parseInt(mask),
      enabled: switched
    };
    this.setState({ isLoad: true });
    // Using axiosInstance which automatically adds auth header and handles 401 errors
    axiosInstance.post(`${USER_CREATE_SERVER_URL}/${userId}/server/create`, payLoad)
      .then((res) => {
        if (res) {
          console.log(`res`, res);
          this.setState({
            msg: res.data.message,
            isLoad: false
          });
          Notifications.notify(this.state.msg, 'Updated', 'success');
          this.props.close();
          this.props.serverListing();
        }
      })
      .catch((err) => {
        this.setState({ isLoad: false });
        // 401/JWT expiry is handled by axiosInstance interceptor
        if (err.response && err.response.status !== 401) {
          const alert = err.response;
          if (alert.data && alert.data.message !== 'invalid or expired jwt') {
            Notifications.notify(alert.data.message, 'Failed', 'error');
          }
        }
      });
  }

  render() {
    const { ip, port, mask, switched, isLoad } = this.state;

    const inputStyle = {
      width: '100%',
      padding: '0.75rem 1rem',
      borderRadius: '10px',
      border: '1px solid var(--color-border)',
      background: 'var(--color-surface)',
      color: 'var(--color-text)',
      fontSize: '0.875rem',
      transition: 'all 0.2s ease',
      outline: 'none'
    };

    const labelStyle = {
      display: 'block',
      fontSize: '0.75rem',
      fontWeight: 600,
      color: 'var(--color-text-secondary)',
      marginBottom: '0.5rem',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    };

    return (
      <div style={{ padding: '0.5rem', animation: 'fadeIn 0.3s ease' }}>

        {/* IP Address Field */}
        <div style={{ marginBottom: '1.25rem' }}>
          <label style={labelStyle}>
            <i className="icon-location4" style={{ marginRight: '0.375rem' }}></i>
            IP Address
          </label>
          <input
            type="text"
            name="ip"
            value={ip}
            onChange={this.handleChange}
            placeholder="e.g., 192.168.1.1"
            style={inputStyle}
            required
          />
        </div>

        {/* Port and Mask Row */}
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.25rem' }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>
              <i className="icon-transmission" style={{ marginRight: '0.375rem' }}></i>
              Port
            </label>
            <input
              type="number"
              name="port"
              value={port}
              onChange={this.handleChange}
              placeholder="5060"
              style={inputStyle}
              required
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>
              <i className="icon-grid6" style={{ marginRight: '0.375rem' }}></i>
              Mask
            </label>
            <input
              type="number"
              name="mask"
              value={mask}
              onChange={this.handleChange}
              placeholder="32"
              style={inputStyle}
              required
            />
          </div>
        </div>

        {/* Enabled Toggle */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '1rem',
            background: 'var(--color-bg-subtle)',
            borderRadius: '12px',
            marginBottom: '1.5rem'
          }}
        >
          <div>
            <div style={{ fontWeight: 600, color: 'var(--color-text)', marginBottom: '0.125rem' }}>
              Server Status
            </div>
            <div style={{ fontSize: '0.8125rem', color: 'var(--color-text-tertiary)' }}>
              {switched ? 'Server will be active' : 'Server will be disabled'}
            </div>
          </div>
          <div
            onClick={this.toggleSwitch}
            style={{
              width: 50,
              height: 28,
              borderRadius: 14,
              background: switched
                ? 'linear-gradient(135deg, #10B981 0%, #059669 100%)'
                : 'var(--color-border)',
              position: 'relative',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
          >
            <div
              style={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                background: 'white',
                position: 'absolute',
                top: 2,
                left: switched ? 24 : 2,
                boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                transition: 'left 0.3s ease'
              }}
            />
          </div>
        </div>

        {/* Submit Button */}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={this.onSubmitForm}
            disabled={isLoad || !ip}
            style={{
              background: isLoad || !ip
                ? 'var(--color-bg-subtle)'
                : 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
              border: 'none',
              borderRadius: '10px',
              padding: '0.75rem 1.5rem',
              color: isLoad || !ip ? 'var(--color-text-tertiary)' : 'white',
              fontWeight: 600,
              fontSize: '0.875rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              cursor: isLoad || !ip ? 'not-allowed' : 'pointer',
              boxShadow: isLoad || !ip ? 'none' : '0 4px 14px rgba(16, 185, 129, 0.3)'
            }}
          >
            {isLoad ? (
              <>
                <i className="icon-spinner2 spinner"></i>
                Creating...
              </>
            ) : (
              <>
                <i className="icon-checkmark2"></i>
                Add Server
              </>
            )}
          </button>
        </div>
      </div>
    );
  }
}

export default AddServerConfig;
